import React from 'react';
import PropTypes from 'prop-types';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import utils from 'helpers/utils';
import { fetchPropertyGroupAccumulated } from 'store/actions/propertygroups/fetchPropertygroups';
import Chip from 'components/ui/chip/Chip';

class PropertyGroupField extends React.Component {
    render() {
        const { display, record, source, style } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        return (
            <span style={ style }>
                <SingleDataContainer
                    action={ fetchPropertyGroupAccumulated }
                    id={ record[source] }
                    resource='propertygroups'
                >
                    { (renderProps) => {
                        const { data } = renderProps;

                        return (
                            <Chip style={ { cursor: 'pointer' } }>
                                <span>{ data[display] }</span>
                            </Chip>
                        );
                    } }
                </SingleDataContainer>
            </span>
        );
    }
}

PropertyGroupField.propTypes = {
    display: PropTypes.string.isRequired,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    style: PropTypes.object,
};

export default PropertyGroupField;



// WEBPACK FOOTER //
// ./src/components/field/PropertyGroupsField.js